import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.array.every.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0) { ; } } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import { useEffect, useState } from 'react';
var isSSR = typeof document === 'undefined';
export function useOutsideClick(ref, isUsed, callback, exceptions) {
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isClosed = _useState2[0],
    setClosed = _useState2[1];
  if (isSSR) {
    return [isClosed, setClosed];
  }
  function checkExceptions(e) {
    var _e$target;
    if (!exceptions || typeof (e === null || e === void 0 ? void 0 : (_e$target = e.target) === null || _e$target === void 0 ? void 0 : _e$target.className) !== 'string') {
      return true;
    }
    if (Array.isArray(exceptions)) {
      return exceptions.every(function (exc) {
        return e.target.className.indexOf(exc) < 0;
      });
    }
    return e.target.className.indexOf(exceptions) < 0;
  }
  function handleClickOutside(event) {
    var forwardClickOutside;
    if (Array.isArray(ref)) {
      forwardClickOutside = ref.every(function (ref) {
        return ref.current && !ref.current.contains(event.target);
      }) && checkExceptions(event);
    } else {
      forwardClickOutside = ref.current && !ref.current.contains(event.target) && checkExceptions(event);
    }
    if (forwardClickOutside) {
      setClosed(true);
      callback === null || callback === void 0 ? void 0 : callback();
    }
  }
  useEffect(function () {
    if (isUsed) {
      window.addEventListener('click', handleClickOutside);
    }
    return function () {
      window.removeEventListener('click', handleClickOutside);
    };
  }, [ref, isUsed]);
  return [isClosed, setClosed];
}
//# sourceMappingURL=useOutsideClick.js.map